// =============================================================================
// sizes.ts - Spacing, padding, border radius, and component sizing scales
// =============================================================================
// All values are NUMBERS (not strings). Units are pixels unless noted.
// The consuming code (theme.ts, components) adds "px" as needed.
// =============================================================================

// ---------------------------------------------------------------------------
// Spacing scale - margin/gap between elements (from Figma Auto Layout)
// Maps token names to pixel values. Used for margins, gaps, and general spacing.
// ---------------------------------------------------------------------------
export const spacing = {
  0: 0,
  2: 2,
  4: 4,
  6: 6,
  8: 8,
  12: 12,
  16: 16,
  24: 24,
  32: 32,
  40: 40,
  48: 48,
  56: 56,
  64: 64,
  72: 72,
  80: 80,
  88: 88,
  96: 96,
  104: 104,
  112: 112,
  120: 120,
} as const;

// ---------------------------------------------------------------------------
// Padding scale - internal component padding (from Figma Auto Layout)
// Identical to spacing for this project.
// ---------------------------------------------------------------------------
export const padding = spacing;

// ---------------------------------------------------------------------------
// Border radius - corner rounding (from Figma corner radius tokens)
// ---------------------------------------------------------------------------
export const borderRadius = {
  0: 0,
  3: 6,
  4: 4,
  8: 8,
  12: 12,
  16: 16,
  24: 24,
  32: 32,
  40: 40,
  48: 48,
  full: 9999,
} as const;

// ---------------------------------------------------------------------------
// Icon sizes - standard icon dimensions (from Figma component sizes)
// ---------------------------------------------------------------------------
export const iconSizes = {
  xs: 14,
  sm: 16,
  md: 20,
  lg: 24,
  xl: 32,
  "2xl": 40,
} as const;

// ---------------------------------------------------------------------------
// Avatar sizes - standard avatar dimensions
// Identical to iconSizes for this project.
// ---------------------------------------------------------------------------
export const avatarSizes = iconSizes;

// ---------------------------------------------------------------------------
// Consolidated sizes export
// ---------------------------------------------------------------------------
export const sizes = {
  spacing,
  padding,
  borderRadius,
  iconSizes,
  avatarSizes,
} as const;

export type Sizes = typeof sizes;
